import { render } from "./CIS-Wistia-Audio.vue?vue&type=template&id=2d8299ba"
import script from "./CIS-Wistia-Audio.vue?vue&type=script&lang=js"
export * from "./CIS-Wistia-Audio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__